import { apiRequest, queryString } from "./http";
import type {
  NotificationPage,
  NotificationReadAllPayload,
  OkResponse,
  UnreadCountResponse,
} from "./generated/openapi";
export type { Notification, NotificationPage } from "./generated/openapi";

export const notificationApi = {
  list: (
    params: { cursor?: string; limit?: number } = {},
    signal?: AbortSignal,
  ) =>
    apiRequest<NotificationPage>(`/api/notifications${queryString(params)}`, {
      signal,
    }),
  unreadCount: (signal?: AbortSignal) =>
    apiRequest<UnreadCountResponse>("/api/notifications/unread-count", {
      signal,
    }),
  markRead: (id: string) =>
    apiRequest<OkResponse>(`/api/notifications/${id}/read`, { method: "POST" }),
  markAllRead: (payload: NotificationReadAllPayload) =>
    apiRequest<OkResponse>("/api/notifications/read-all", {
      method: "POST",
      body: JSON.stringify(payload),
    }),
};
